import React from 'react';
import { FormattedMessage } from 'react-intl';
import Box from 'carbon-react/lib/components/box/';
import { Sidebar } from '@futrli/ui-components';
import Typography from 'carbon-react/lib/components/typography';

import { COADisplayAccount } from '../../../../chart-of-accounts/types';
import { SwitchRuleWizardContainer } from './switch-rule-wizard-container';

interface SwitchRuleSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  account: COADisplayAccount;
}

export const SwitchRuleSidebar = ({ isOpen, onClose, account }: SwitchRuleSidebarProps) => (
  <Sidebar
    header={
      <Box>
        <Typography variant="h2" fontWeight="700">
          <FormattedMessage id="common.add_switch_rule" defaultMessage="Add switch rule" />
        </Typography>
        <Typography fontSize="16px" mt={1} mb={0}>
          {account.name}
        </Typography>
      </Box>
    }
    onCancel={onClose}
    open={isOpen}
  >
    <SwitchRuleWizardContainer onClose={onClose} account={account} />
  </Sidebar>
);
